import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import type { Medication } from 'src/app/types';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import {
  MedicationHeader,
  MedicationItem,
  MedicationLabel,
} from '../../../Pages/LoggedInTransfer/Experiment/Confirmation/styles';
import { getMedicationFormValueName } from '../utils';

export interface MedicationListProps {
  medications: (string | Medication)[];
  hideMedicationHeader?: boolean;
}

export const MedicationList = ({ medications, hideMedicationHeader = false }: MedicationListProps) => {
  return (
    <>
      {!hideMedicationHeader && <MedicationHeader variant="h4">Your medications</MedicationHeader>}

      {medications.map((medication, idx) => {
        const medicationName = getMedicationFormValueName(medication);

        return (
          <MedicationItem key={`${medicationName}-${idx}`}>
            <CapsuleIcon width={24} height={24} block iconString={CAPSULE_ICON_STRINGS.pill_bottle} />
            <MedicationLabel>{medicationName}</MedicationLabel>
          </MedicationItem>
        );
      })}
    </>
  );
};
